/**
 * Chat page - Main entry point for the chat UI.
 *
 * Uses UnifiedChat component which provides:
 * - Integrated voice mode (overlay, not separate page)
 * - Real-time transparency system
 * - File upload support
 * - Enhanced message display
 */

import { UnifiedChat } from '@/components/chat'

export default function Chat() {
  return <UnifiedChat />
}
